import styled, { css } from "styled-components";


type DotProps = {
	status:boolean
}

export const SummarePanelHeaderContainer = styled.div`
  margin-bottom: 20px;
`
export const StatusTitle = styled.div`
  font-size: 18px;
  display: inline;
  color: #23262f;
  margin-right: 20px;
`;

export const Status = styled.div`
  display: inline;
  position: relative;
`;

export const Dot = styled.span<DotProps>`
  background-color: ${props => props.status ? "green" : "red"};;
  width: 5px;
  height: 5px;
  position: absolute;
  left: -10px;
  top: 9px;
  border-radius: 50px;
`;
